module.exports = __webpack_public_path__ + "static/media/success_screen_bg.2c05d1e5.png";